export default __webpack_public_path__ + "static/media/loss-setup-step2.518869d3.gif";